// extracted by mini-css-extract-plugin
export default {"wrapper":"LocationCard_wrapper__k+BZe","name":"LocationCard_name__4CTi1"};